import React from 'react';
import { IconProps } from '.';

const SvgColoredPulse = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#C8D2FD'
        d='M1.333 4A2.667 2.667 0 0 1 4 1.333h16A2.667 2.667 0 0 1 22.666 4v16A2.667 2.667 0 0 1 20 22.667H4A2.667 2.667 0 0 1 1.333 20V4Z'
      />
      <path
        fill='#4769F7'
        fillRule='evenodd'
        d='M9.621 7.2a.8.8 0 0 1 .69.434l4.049 7.872 1.713-3.723a.8.8 0 0 1 .727-.465H20a.8.8 0 0 1 0 1.6h-2.688l-2.185 4.75a.8.8 0 0 1-1.439.031L9.556 9.664 7.891 12.52a.8.8 0 0 1-.691.397H4a.8.8 0 0 1 0-1.6h2.74l2.169-3.72A.8.8 0 0 1 9.62 7.2Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredPulse;
